import {useEffect, useState} from 'react';

/**
 * The current time, refreshed on an interval so time-based rendering (such as
 * the Orders list's 4-hour urgency flag) keeps up while a page stays open.
 *
 * @param {number} intervalMs how often to re-read the clock
 * @return {number} ms since the epoch
 */
export const useNow = (intervalMs = 60000) => {
    const [now, setNow] = useState(() => Date.now());

    useEffect(
        () => {
            const timer = setInterval(() => setNow(Date.now()), intervalMs);
            return () => clearInterval(timer);
        }, [intervalMs]
    );

    return now;
};
